<template>
  <table class="TB_COLLAPSE2" style="width: 100%">
    <thead>
      <tr>
        <th class="text-left th">站别类型</th>
        <th v-for="(res, key) in data.data" class="text-left th">
          <Checkbox
            class="tript"
            v-model="res.checked"
            :disabled="!res.data.length"
            @on-change="($event) => catenaCheck($event, res, key)"
            >{{ res.title }}
          </Checkbox>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="text-left">
          <Checkbox
            class="siteIpt"
            v-model="data.checked"
            @on-change="siteCheck(data.checked)"
            >{{ data.title }}</Checkbox
          >
        </td>
        <td v-for="(bres, baries) in data.data" :key="baries" class="text-left">
          <CheckboxGroup v-model="selected">
            <Checkbox
              v-for="(item, index) in bres.data"
              :key="index"
              ref="test"
              class="gameipt block"
              :label="item.gameid"
              >{{ item.gamename }}</Checkbox
            >
          </CheckboxGroup>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
      selected: []
    };
  },
  computed: {
    gamelist () { // 展开 data.data 游戏的id列表
      const array = Object.keys(this.data.data).reduce((acc, val) => {
        let it = this.data.data[val]
        let array = it.data.map(res => res.gameid)
        acc.push(...array)
        return acc
      }, [])
      return array
    }
  },
  watch: {
    selected (val) { // 判断游戏选取数量的去句选
      let keyLength = Object.keys(this.data.data).length // 群组数量（预设為未勾选），可视為 *未勾选的群组数量*
      Object.keys(this.data.data).forEach(key => {
        let gameGruop = this.data.data[key]
        if (gameGruop.data.length) gameGruop.checked = gameGruop.data.every(it => val.includes(it.gameid)) // 判断val的值 是否已符合，游戏群组内的所有data if為該群組有遊戲才做判斷
        if (gameGruop.checked) keyLength-- // 群组内游戏全选 = 群组勾选；*未勾选的群组数量* -1
      })
      this.data.checked = keyLength == 0 // keyLen = 0 => 群组皆勾选
    }
  },
  methods: {
    siteCheck (check) { // 注入站点所有checkbox 并且句选
      this.selected = check ? this.gamelist : []
    },
    catenaCheck (state, array, key) { // 确认哪个游戏类别 注入游戏id 并且句选
      const listid = array.data.map(it => it.gameid) // 取得这个游戏类别的id
      this.data.data[key].checked = state // 切换状态
      if (state) {
        // push 游戏id列表, 去除重复的
        const _selected = this.selected.slice()
        _selected.push(...listid)
        this.selected = Array.from(new Set(_selected)) // 去除重复的
      } else {
        // this.selected使用 filter移除符合listid的id
        this.selected = this.selected.filter(it => !listid.some(item => item == it))
      }
    },
    returnId () {
      return this.selected;
    }
  }
};
</script>

<style lang="scss">
.gameSelect {
  .TB_COLLAPSE2 {
    margin: 0px;
    padding: 0px;
    border-collapse: collapse;
    border-style: hidden;
    border-width: 0;
    width: 100%;
    table-layout: fixed;
    word-break: break-all;
    thead th {
      background-color: #1d3c78;
      color: #fff;
      padding-left: 20px;
      border-left: solid 1px #5e5a61;
    }
    tbody td {
      text-align: left;
      padding: 0px;
      vertical-align: top;
      border: solid 1px #5e5a61;
    }
    .siteIpt {
      margin: 2% auto 2% 20px;
    }
    .gameipt {
      margin: 5% auto 5% 20px;
    }
  }
}
</style>